require('./bootstrap');
require('./swiper');
require('./aos');
require('./custom');
require('./popup');


import Vue from "vue";
// import router from "./router";
import ViaCep from 'vue-viacep'

import './axios'
// import './bugsnag'

Vue.use(ViaCep);

Vue.component('validate-customer', require('./components/ValidateCustomer.vue').default);
Vue.component('search-customer', require('./components/SearchCustomer.vue').default);
Vue.component('register-customer', require('./components/RegisterCustomer.vue').default);
Vue.component('payment', require('./components/Payment.vue').default);
Vue.component('profile', require('./components/Profile.vue').default);
Vue.component('profile-data', require('./components/ProfileData.vue').default);
Vue.component('profile-apps', require('./components/ProfileApps.vue').default);

const app = new Vue({
  el: '#app',
  // router
});
